(function () {
    "use strict";

    let options = {
        type: 'fade',
        autoplay: true,
        interval: 5000,
        speed: 1000,
        rewind: true,
        perPage: 1,
        perMove: 1,
        height: '450px',
        arrows: false,
        easing: 'ease-in',
        breakpoints: {
            768: {
                height: '300px',
            },
        }
    };

    new Splide("#header-carrousel", options).mount();

})();


